<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          SPU：{{ formData.amzSpuNo }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form ref="form" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10">
        <div @click="previewImage" class="mr-3">
          <el-image
            style="width: 130px; height: 130px;"
            fit="scale-down"
            :src="formData.defaultImageUrl"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic-square.jpg"
                style="width: 130px; height: 130px;"
              />
            </div>
          </el-image>
        </div>

        <el-col :span="22">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_label_goodsNameCn') || '中文名称'"
              >
                <el-input v-model="formData.goodsName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.replenishment_label_goodsNameEn') || '英文名称'
                "
              >
                <el-input v-model="formData.goodsNameEn" readonly />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.order_form_label_brand') || '品牌'"
              >
                <el-input v-model="formData.brandName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.table_label_category') || '分类'"
              >
                <el-input v-model="formData.categoryFullName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.isVc') || '是否VC产品'"
              >
                <el-input
                  :value="
                    formData.isVc === 'Y'
                      ? $l('INDEX.YES') || '是'
                      : $l('INDEX.NO') || '否'
                  "
                  readonly
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-form-item :label="''" class="mr-3">
          <br />
          <el-button
            plain
            type="primary"
            style="width:130px"
            @click="spuImageVisible = true"
          >
            {{ $l('btn_queryImage') || '查看图片' }}
          </el-button>
        </el-form-item>
        <el-col :span="22">
          <el-row :gutter="10" type="flex" justify="end">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.table_label_succession') || '系列'"
                prop="collectionName"
                ref="collectionItem"
              >
                <el-input v-model="formData.collectionName" readonly />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_design') || '企划'"
              >
                <el-input v-model="formData.designName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_merchandiser') || '业务开发人员'"
              >
                <el-input v-model="formData.merchandiserName" readonly />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row v-if="type === 'reject'">
        <el-col :span="24">
          <el-form-item :label="'驳回原因'" prop="rejectReason">
            <el-input
              v-model="formData.rejectReason"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              type="textarea"
              :maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <SpuImage
      v-if="spuImageVisible"
      :visible.sync="spuImageVisible"
      :amzSpuCode="this.formData.amzSpuCode"
      :title="$l('form_label_picture_maintenance') || '图片维护'"
    />

    <div v-show="false" class="image-viewer" v-viewer="{ movable: true }">
      <img
        v-for="item in displayImageUrls"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>

    <el-dialog
      width="30%"
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      append-to-body
      v-el-dialog-drag
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="reject()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import SpuImage from './spu-image'
export default {
  mixins: [EditLoading],
  components: { SpuImage },
  props: {
    type: { type: String, default: '' },
    amzSpuCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      rules: {
        rejectReason: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
      spuImageVisible: false,
    }
  },
  computed: {
    displayImageUrls() {
      const { listImageUrl } = this.formData
      return listImageUrl?.map((item) => item.displayImageUrl) || []
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzSpuCode) return
      const res = await this.$api
        .ecomAmzSpuDetailApi({ amzSpuCode: this.amzSpuCode })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    previewImage() {
      if (!this.displayImageUrls || !this.displayImageUrls.length) return
      const viewer = this.$el.querySelector('.image-viewer').$viewer
      const index = this.displayImageUrls.findIndex(
        (item) => item === this.formData.defaultImageUrl
      )
      viewer.view(index)
      viewer.show()
    },
    async approved() {
      const confirm = await this.$confirm(
        '是否要通过该SPU转正申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const listAmzSpuCode = [this.amzSpuCode]
      const res = await this.$api
        .ecomAmzSpuApprovedApi({ listAmzSpuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error('通过失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '通过成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    async reject() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const confirm = await this.$confirm(
        '是否要驳回该SPU转正申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzSpuRejectApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error('驳回失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '驳回成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
      this.loadingClose()
    },
    cancel() {
      if (['approved', 'detail'].includes(this.type)) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.el-row {
  display: flex;
  align-items: stretch;
}
.image-col {
  padding: 0;
}
.image-wrapper {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
}
.text-col {
  padding: 0;
}
.text-wrapper {
  padding: 20px;
}
</style>
